import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject, effect } from '@angular/core';

import { TabsModule } from 'primeng/tabs';
import { Plans } from './plans/plans';
import { Subscription } from './subscription/subscription';
import { Invoices } from './invoices/invoices';
import { Subscription as SubscriptionService } from '@core/services/subscription';
import { Signalr } from '@core/services/signalr';

@Component({
  selector: 'app-billing',
  imports: [TabsModule, Plans, Subscription, Invoices],
  templateUrl: './billing.html',
  styleUrl: './billing.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Billing implements OnInit, OnDestroy {
  private signalr = inject(Signalr);

  constructor(public subscriptionService: SubscriptionService) {
    // React to subscription plan changes
    effect(() => {
      const message = this.signalr.subscriptionPlanChanged();
      if (message) {
        console.log('Subscription plan changed, reloading subscription data', message);
        this.subscriptionService.loadSubscription();
      }
    });
  }

  ngOnInit(): void {
    this.subscriptionService.loadSubscription();
  }

  ngOnDestroy(): void {
    // SignalR cleanup is handled by the service itself
  }
}
